// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"2d0c21f4","43":"80dae1a0","251":"97fb0fb6","458":"6b202d6c","524":"02071883","547":"0e2c6848","730":"28c40a5c","746":"bdccebad"}[chunkId] + ".chunk.js";
};